export function getLetterLabel(index: number): string {
  return String.fromCharCode(97 + index);
}

export const ROMAN_NUMERALS = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

export function getRomanLabel(index: number): string {
  return ROMAN_NUMERALS[index] || `${index + 1}`;
}
